/**
 * Builds an auth-page URL (`/signin` or `/authenticate`) that captures the user's
 * current in-app location as a `return_url`, so it isn't lost when the global error
 * handler sends them to re-authenticate (no or expired session → /signin, or an
 * account that requires a second factor → /authenticate).
 *
 * Landing them back on that page is the consuming side's job: sanitizeReturnUrl
 * validates the return_url and getAccountTargetUrl handles account routing. The
 * cold-deep-link (no session) path is verified; expiry and MFA follow the same
 * mechanism but are inferred, not separately tested.
 */
export const getAuthRedirectWithReturn = (
	basePath: "/signin" | "/authenticate"
) => {
	const returnUrl = window.location.pathname + window.location.search;
	return `${basePath}?return_url=${encodeURIComponent(returnUrl)}`;
};
